<template>
  <div>
    <div class="field" :class="[item.layout, layout, {'modify':modify}]" :style="formItemStyle">
      <div class="name" v-if="item.name">
        <span class="flag" v-if="item.required">*</span>
        <span class="b-title">{{`${item.name}${!modify?'：':''}`}}</span>
        <slot name="extra"></slot>
        <slot name="extra2"></slot>
      </div>
      <div class="filed-right">
        <div
        class="input-wrapper"
        :class="{'focus-ui': focused||warning.valid===false, 'noborder': !haveBorder, 'tgo-textarea': formItemStyle === 'textarea', 'iview': iview}">
          <slot name="input"></slot>
          <slot name="input-extra"></slot>
        </div>
        <div class="warn" v-if="warning.valid===false">{{warning.message||''}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import check from './check'

export default {
  data () {
    return {
      warning: {},
      warns: {},
      focused: false
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return { name: '', required: false }
      }
    },
    haveBorder: {
      type: Boolean,
      default: true
    },
    'form-item-style': {
      type: String
    },
    iview: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: '' // apply
    },
    modify: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    blurFn (item, info) {
      this.focused = false
      if (item.regName) {
        if (item.key === 'focus_areas_tags' && info[item.key] && Array.isArray(info[item.key]['1'])) {
          this.warning = check[item.regName](info[item.key]['1'] + '', item.warnTag || '')
        } else {
          this.warning = check[item.regName](info[item.key] + '', item.warnTag || '')
        }
        if (item.required) {
          this.$emit('setOKList', { 'warning': this.warning, 'key': item.key })
        }
      }
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.field
  margin-bottom: 18px
  display: flex
  align-items: center
  &.modify
    align-items: flex-start
  &.apply
    display: block
    .filed-right
      margin-left: 48px
  .name
    display: flex
    align-items: center
    transition: all 1s linear
    .b-title
      margin-right: 15px
      word-break: keep-all
    .flag
      color: $primary3
      font-size: 24px
      margin-right: 5px
  .filed-right
    flex-grow: 1
    .input-wrapper
      // margin-left: 48px
      padding: 4px 7px
      border: 1px solid #ccc
      border-radius: 3px
      transition: all .3s
      &:hover
        border-color: $primary3
      &.iview
        padding: 0px
      &.tgo-textarea
        padding: 8px
      &.focus-ui
        box-shadow: inset 0 1px 6px rgba(255, 90, 5, 0.1)
        border-color: $primary3
        &.noborder
          border: none
          box-shadow: none
      &.noborder
        border: none
      .text-input
        display: inline-block
        width: 100%
        height: 28px
        outline: none
        border: none
        background-color: transparent
        font-size: 14px
        -webkit-appearance: textfield
    .warn
      font-size: 14px
      color: $primary3

</style>
